import styled from "styled-components"

export const ModalWrapper = styled.div`

.amep {
    &_overlay {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(1, 1, 1, 35%);
        z-index: 10;
        transition: all 0.3s linear;
    }
    &_container {
        position: fixed;
        top: 20%;
        width: 600px;
        left: 40%;
        padding: 12px;
        border-radius: 4px;
        background-color: #fff;
        z-index: 20;
        transition: all 0.3s linear;
    }
   
}
`